<template>
  <div class="home bg-trans">
    <div class="wrapper-content registerHeader">
      <!-- <div class="breadcrumb_box ">
        <div class="container-fluid">
          <h2>Privacy Policy</h2>
        </div>
      </div>-->

      <div class="addmoney newaddress static-pages">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <!-- <vue-editor v-model="content"></vue-editor> -->
              <div v-html="content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStaticData } from "./../services/api";
export default {
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.getData();
  },
  watch: {
    $route(to, from) {
      this.getData();
    }
  },
  methods: {
    getData() {
      var requestData = { vendor_id: localStorage.getItem("vendorId") };
      getStaticData(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            console.log("result", result);
            var a = result.data.content;
            if (this.$route.path == "/privacy-policy") {
              var pp = a.filter(item => item.slug == "PP");
              this.content = pp[0].description;
            } else if (this.$route.path == "/about-us") {
              var au = a.filter(item => item.slug == "abt");
              this.content = au[0].description;
            } else if (this.$route.path == "/terms-and-conditions") {
              var tc = a.filter(item => item.slug == "T&C");
              this.content = tc[0].description;
            } else {
              var rc = a.filter(item => item.slug == "R&C");
              this.content = rc[0].description;
            }
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>